import { render, staticRenderFns } from "./SummaryCCRIS.vue?vue&type=template&id=621a787c"
import script from "./SummaryCCRIS.vue?vue&type=script&lang=js"
export * from "./SummaryCCRIS.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports